import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit } from "react-icons/fa";

const ViewProject = () => {
  const [tableData, setTableData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const itemsPerPage = 10;
  const navigate = useNavigate(); // Used to navigate to another page

  useEffect(() => {
    setTableHeader([
      { dbParam: "sr_n", displayName: "Sr. No" },
      { dbParam: "projectName", displayName: "Project Name" },
      { dbParam: "spvName", displayName: "SPV Name" },
      { dbParam: "projectId", displayName: "Project ID" },
      { dbParam: "startDate", displayName: "Start Date" },
      { dbParam: "endDate", displayName: "End Date" },
      { dbParam: "status", displayName: "Status" },
      { dbParam: "action", displayName: "View / Edit" }, // Single Action column
    ]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    console.log("Base URL:", baseURL);

    // Fetching data from API
    axios
      .get(`${baseURL}get_all_project_summary`)
      .then((response) => {
        setTableData(
          response.data.map((project, index) => ({
            sr_n: index + 1, // Auto-generate Sr. No
            projectName: project.projectName,
            spvName: project.spvName,
            projectId: project.projectId,
            startDate: project.startDate,
            endDate: project.endDate,
            status: project.status,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    const sortedData = [...tableData].sort((a, b) => {
      if (a[property] < b[property]) return isAsc ? 1 : -1;
      if (a[property] > b[property]) return isAsc ? -1 : 1;
      return 0;
    });

    setTableData(sortedData);
  };

  const handleEditClick = (row) => {
    navigate(`/edit-project/${row.projectId}`);
  };

  const handleViewClick = (row) => {
    navigate(`/view-project-details/${row.projectId}`); // Navigate to project details page
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = tableData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage * itemsPerPage < tableData.length ? prevPage + 1 : prevPage
    );
  };

  return (
    <div className="mt-5 space-y-2">
      <Table
        tableHeaders={tableHeader}
        tableData={currentData.map((row) => ({
          ...row,
          action: (
            <div className="flex justify-center space-x-2">
              <FaEdit
                className="text-[#424752] cursor-pointer"
                onClick={() => handleEditClick(row)}
              />
              <FaEye
                className="text-[#424752] cursor-pointer"
                onClick={() => handleViewClick(row)}
              />
            </div>
          ),
        }))}
        order={order}
        orderBy={orderBy}
        handleSort={handleSort}
      />
      <div className="flex justify-between items-center">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-200 rounded"
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {Math.ceil(tableData.length / itemsPerPage)}
        </span>
        <button
          onClick={handleNextPage}
          disabled={currentPage * itemsPerPage >= tableData.length}
          className="px-4 py-2 bg-gray-200 rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ViewProject;
